<template>
    <div>
        <el-form ref="searchForm" :model="searchData" inline>
            <el-form-item label="UID">
                <el-input v-model.number="searchData.user_id" size="mini" />
            </el-form-item>
            <el-form-item label="状态">
                <el-select v-model="searchData.status" size="mini" placeholder="请选择" class="policy-box-input">
                    <el-option
                        v-for="item in options"
                        :key="item.key"
                        :label="item.value"
                        :value="item.key">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button size="mini" @click="handlerSearch">
                    查找
                </el-button>
            </el-form-item>
        </el-form>
        <el-table
            :data="data"
            @sort-change="handlerSort"
            :default-sort = "{prop: 'id', order: 'descending'}"
        >
            <el-table-column
                prop="id"
                label="ID"
                sortable="custom"
            />
            <el-table-column
                prop="user_id"
                label="UID"
            />
            <el-table-column
                prop="nickname"
                label="昵称"
            />
            <el-table-column
                label="头像"
            >
                <template slot-scope="{row}">
                    <el-image style="width: 50px;" :src="row.avatar"/>
                </template>
            </el-table-column>
            <el-table-column
                prop="mobile"
                label="手机号"
            />
            <el-table-column
                prop="status"
                label="状态"
                :formatter="function(v) { return status[v['status']] }"
            />
            <el-table-column
                prop="amount"
                label="提现金额(元)"
                :formatter="function(v) { return (v['amount'] / 100).toFixed(2) }"
            />
            <el-table-column
                prop="time"
                label="提现时间"
            />
            <el-table-column label="操作" width="80px">
                <template slot-scope="scope">
                    <el-button
                        v-if="scope.row.status === 0 || scope.row.status === 200"
                        type="primary"
                        size="mini"
                        @click="handleClickDetail(scope.row.id)"
                    >审核</el-button>
                    <el-button
                        v-else
                        type="default"
                        size="mini"
                        @click="handleClickDetail(scope.row.id)"
                    >详情</el-button>
                </template>
            </el-table-column>
        </el-table>
        <pager
            api="withdraw_list"
            :filter="filter"
            :sort="sort"            
            model="wallet"
            @data-changed="onDataChanged"
        />
        <el-dialog :visible.sync="showViewDetail">
            <el-form label-position="right">
                <div class="txt">实名信息</div>
                <el-form-item label="姓名：" label-width="150px">
                    <el-input v-model="detailData.identity_info.card_name" disabled="disabled"></el-input>
                </el-form-item>
                <el-form-item label="身份证号：" label-width="150px">
                    <el-input v-model="detailData.identity_info.card_number" disabled="disabled"></el-input>
                </el-form-item>
                <el-form-item label="身份证正面照片：" label-width="150px">
                    <el-image :src="'data:image/jpeg;base64,' + card_positive"/>
                </el-form-item>
                <el-form-item label="身份证反面照片：" label-width="150px">
                    <el-image :src="'data:image/jpeg;base64,' + card_back"/>
                </el-form-item>
                <div class="txt">银行卡信息</div>
                <el-form-item label="银行：" label-width="150px">
                    <el-input :value="bankName" disabled="disabled"></el-input>
                </el-form-item>
                <el-form-item label="开户行：" label-width="150px">
                    <el-input v-model="detailData.finance_info.bank_opening" disabled="disabled"></el-input>
                </el-form-item>
                <el-form-item label="卡号：" label-width="150px">
                    <el-input v-model="detailData.finance_info.card_number" disabled="disabled"></el-input>
                </el-form-item>
                <div class="txt">提现信息</div>
                <el-form-item label="用户ID：" label-width="150px">
                    <el-input v-model="detailData.withdraw_info.user_id" disabled="disabled"></el-input>
                </el-form-item>
                <el-form-item label="金额(元)：" label-width="150px">
                    <el-input :value="(detailData.withdraw_info.amount/100).toFixed(2)" disabled="disabled"></el-input>
                </el-form-item>
                <el-form-item label="时间：" label-width="150px">
                    <el-input v-model="detailData.withdraw_info.time" disabled="disabled"></el-input>
                </el-form-item>
                <el-form-item label="状态：" label-width="150px">
                    <el-input :value="getStatusText(detailData.withdraw_info.status)" disabled="disabled"></el-input>
                </el-form-item>
                
                <!--  status === 0  -->
                <div class="deal-box" v-if="detailData.withdraw_info.status === 0">
                    <el-form-item label="审核状态：" label-width="150px">
                        <el-select v-model="auditStatus" size="mini" placeholder="请选择" class="policy-box-input">
                            <el-option
                                v-for="item in auditStatusOptions"
                                :key="item.key"
                                :label="item.value"
                                :value="item.key">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="失败原因：" label-width="150px" v-if="!auditStatus">
                        <el-select v-model="auditFail" size="mini" placeholder="请选择" class="policy-box-input">
                            <el-option
                                v-for="item in auditFailMessageOptions"
                                :key="item"
                                :label="item"
                                :value="item">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-button type="primary" @click="submit">提交</el-button>
                </div>
                <div class="deal-box" v-else-if="detailData.withdraw_info.status === 200">
                    <el-form-item label="处理状态：" label-width="150px">
                        <el-select v-model="dealStatus" size="mini" placeholder="请选择" class="policy-box-input">
                            <el-option
                                v-for="item in dealStatusOptions"
                                :key="item.key"
                                :label="item.value"
                                :value="item.key">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="失败原因：" label-width="150px" v-if="!dealStatus">
                        <el-select v-model="dealFail" size="mini" placeholder="请选择" class="policy-box-input">
                            <el-option
                                v-for="item in dealFailMassegeOptions"
                                :key="item"
                                :label="item"
                                :value="item">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="银行流水：" label-width="150px" v-else>
                        <el-input v-model="bank_log"></el-input>
                    </el-form-item>
                    <el-button type="primary" @click="submit" class="btn">提交</el-button>
                </div>
                <div class="deal-box" v-else-if="detailData.withdraw_info.status === 999">
                    <el-form-item label="银行流水：" label-width="150px">
                        <el-input v-model="detailData.withdraw_info.bank_log" disabled="disabled"></el-input>
                    </el-form-item>
                </div>
                <div class="deal-box" v-else>
                    <el-form-item label="失败原因：" label-width="150px">
                        <el-input v-model="detailData.withdraw_info.remark" disabled="disabled"></el-input>
                    </el-form-item>
                </div>
                
            </el-form>
            
        </el-dialog>
    </div>
</template>
<script>
import Pager from "../ui/Pager"
import request from "@/api/request";

const status = {0: '创建',200: '审核成功',910: '钱包失败', 920: '审核失败',998: '提现失败',999: '提现成功'}
const options = [{key: 0,value: '创建'},{key: 200,value: '审核成功'},{key: 910,value: '钱包失败'},{key: 920,value: '审核失败'},{key: 998,value: '提现失败'},{key: 999,value: '提现成功'}]
const auditStatusOptions = [{key: true, value: '审核成功'},{key: false,value: '审核失败'}]
const auditFailMessageOptions = ['通道故障',
    '账户名、卡号或开户行错误',
    '非本人银行卡',
    '账户存在风险',
    '账户涉嫌违规',
    '其他原因']
const dealStatusOptions = [{key: true, value: '处理成功'},{key: false,value: '处理失败'}]
const dealFailMassageOptions = ['通道故障', '账户名、卡号或开户行错误', '非本人银行卡', '账户存在风险', '账户涉嫌违规', '其他原因']
export default {
    components: {
      Pager  
    },
    data(){
        return {
            searchData: {
                user_id: '',
                status: ''
            },
            status: status,
            options: options,
            auditStatusOptions: auditStatusOptions,
            auditStatus: null,//审核状态,status === 0
            auditFailMessageOptions: auditFailMessageOptions,
            auditFail: '',//失败原因,status === 0
            dealStatusOptions: dealStatusOptions,
            dealStatus: null,//处理状态， status === 200
            dealFailMassegeOptions: dealFailMassageOptions,
            dealFail: '',//处理失败原因 ,status === 200
            data: [],
            filter: {},
            sort: [
                {
                    field: 'id',
                    reverse: true
                }
            ],
            detailData: {
                withdraw_info:{
                    amount: 0,
                    time:"",
                    user_id:0,
                    bank_log:null,
                    remark:null,
                    status:0
                },
                identity_info:{
                    card_number:"",
                    card_name:"",
                    card_positive:"",
                    card_back:""
                },
                finance_info:{
                    bank_code:"",
                    card_number:"",
                    bank_opening:""
                }
            },
            showViewDetail: false,
            bank_log: '',
            card_positive:"",
            card_back:"",
            id: 0,
            bankName: ''
        }
    },
    methods:{
        handlerSearch(){
            //查找
            let filter = {}
            if (this.searchData.user_id) {
                filter.user_id = this.searchData.user_id
            }
            if (this.searchData.status || this.searchData.status === 0) {
                filter.status = this.searchData.status
            }
            this.filter = filter
        },
        handlerSort(column) {
            this.sort = [
                {
                    field: column.prop,
                    reverse: column.order === 'descending'
                }
            ]
        },
        onDataChanged: function (data) {
            this.data = data
        },
        handleClickDetail(id){
            this.id = id
            request.wallet
                .post("withdraw_info_get", {
                    withdraw_id: id,
                })
                .then(resp => {
                    this.detailData = resp.data
                    this.getImage()
                    this.getBankName()
                    this.showViewDetail = !this.showViewDetail
                })
        },
        getStatusText(status){
            for(let i in this.options) {
                if(this.options[i].key === status) {
                    return this.options[i].value
                }
            }
        },
        getBtnTxt(status) {
            if(status === 0 || status === 200) {
                return '审核'
            } else {
                return '详情'
            }
        },
        getBankName(){
            request.front
                .post("bank_list")
                .then(resp => {
                    let bankList = resp.data
                    for(let i in bankList) {
                        if(bankList[i].code === this.detailData.finance_info.bank_code) {
                            console.log(bankList[i])
                            this.bankName = bankList[i].name
                        }
                    }
                })
        },
        getImage(){ 
            const paths = [
                {
                    type: 'id_card',
                    path: this.detailData.identity_info.card_positive
                },
                {
                    type: 'id_card',
                    path: this.detailData.identity_info.card_back
                }
            ]
            request.tools
                .post("file_get", {files: paths})
                .then(resp => {
                    console.log(resp)
                    this.card_positive = resp.data.list[0]
                    this.card_back = resp.data.list[1]
                })
        },
        submit(){
            //status === 0
            if(this.detailData.withdraw_info.status === 0) {
                const opt = {
                    withdraw_id: this.id,
                    verify: this.auditStatus,
                    remark: this.auditFail
                }
                for ( let key in opt ){
                    if ( opt[key] === ''){
                        delete opt[key]
                    }
                }
                request.wallet
                    .post("withdraw_verify", opt)
                    .then(() => {
                        this.showViewDetail = !this.showViewDetail
                        this.auditStatus = null
                        this.auditFail = ''
                    })
            } else if(this.detailData.withdraw_info.status === 200) {
                const opt = {
                    withdraw_id: this.id,
                    ret: this.dealStatus,
                    remark: this.dealFail,
                    bank_log: this.bank_log
                }
                for ( let key in opt ){
                    if ( opt[key] === ''){
                        delete opt[key]
                    }
                }
                request.wallet
                    .post("withdraw_process", opt)
                    .then(() => {
                        this.showViewDetail = !this.showViewDetail
                        this.dealStatus = null
                        this.dealFail = ''
                        this.bank_log = ''
                    })
            }
        }
    }
}
</script>
<style scoped>
.el-input{
    width: 300px !important;
}
.el-table{
    margin: 0 0 50px 0;
}
.el-dialog .el-image{
    max-width: 600px;
}
.txt{
    margin: 0 0 10px 50px;
    color: #333333;
    font-size: 16px;
    font-weight: 500;
}
.btn{
    margin: 0 0 0 70px !important;
}
</style>
